export default __webpack_public_path__ + "static/media/DSC_0577.faf0fa4b.webp";